import { createSlice } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";

let initialState = {
  propertyInfo: {
    calculatedSize: {},
    location: {},
    furnished: {},
    budgetPricing: {},
    leaseTermsDuration: {},
    accessibilityTransport: {},
    numberOfEmployees: 0,
    employeesPerArea: 0,
  },
};

export const propertySlice = createSlice({
  name: "property",
  initialState,
  reducers: {
    updatePropertyInfo: (state, action) => {
      state.propertyInfo = { ...state.propertyInfo, ...action.payload };
    },
    removePropertyInfo(state) {
      state.propertyInfo = initialState.propertyInfo; // Reset to initial state
    },
  },
});

export function usePropertyStore() {
  const propertyInfo = useSelector((state) => state.property.propertyInfo);
  const dispatch = useDispatch();

  return {
    propertyInfo,
    updatePropertyInfo: (payload) => dispatch(updatePropertyInfo(payload)),
    removePropertyInfo: () => dispatch(removePropertyInfo()),
  };
}

export const { updatePropertyInfo, removePropertyInfo } = propertySlice.actions;
export default propertySlice.reducer;
